// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"patient-table_wrapper__4r70p","tableWrapper":"patient-table_tableWrapper__iaYCs","cells":"patient-table_cells__2rceQ"};